import CurrencyInput from './CurrencyInput';
import ControlledComponent from '../../../utils/ControlledComponent';

export const ControlledCurrencyInput = ControlledComponent(CurrencyInput);

export default CurrencyInput;
